import {
  PRODUCT_CONFIGURATOR_RECEIVE,
  PRODUCT_CONFIGURATOR_SEND,
  PRODUCT_CONFIGURATOR_UPDATE,
  PRODUCT_CONFIGURATOR_ERROR,
  ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  variantData: [],
  configMessage: '',
  buyButtonEnabled: true,
  returnMessage: '',
  errors: {},
};

export const productConfigurator = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_CONFIGURATOR_RECEIVE:
    case PRODUCT_CONFIGURATOR_UPDATE:
    case PRODUCT_CONFIGURATOR_SEND:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case PRODUCT_CONFIGURATOR_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
